import { render, staticRenderFns } from "./nodepush2.vue?vue&type=template&id=271f0b3c&"
import script from "./nodepush2.vue?vue&type=script&lang=js&"
export * from "./nodepush2.vue?vue&type=script&lang=js&"
import style0 from "./nodepush2.vue?vue&type=style&index=0&id=271f0b3c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports